var DdeStatusType = {
  NOT_CONNECTED: 'NOT CONNECTED',
  CONNECTED: 'CONNECTED',
  STREAMING: 'STREAMING'
}
export default DdeStatusType;

